module.exports = __webpack_public_path__ + "img/illustration-4.d2517957.png";